/* eslint-disable no-unused-vars */

// import * as d3 from 'd3'; // using only this work

import { axisTop, axisLeft, axisBottom } from 'd3-axis';
import { scaleBand } from 'd3-scale';
import { select } from 'd3-selection';
import { csv } from 'd3-fetch';

// import { Placement } from "tippy.js";
// import 'tippy.js/dist/tippy.css'; // optional for styling
// import 'tippy.js/themes/light.css';

import tippy from 'tippy.js';
import { roundArrow } from 'tippy.js';

////////////////

const lowRate = 2.460;
const highRate = 3.240;


function makeSelect() {
	const counties = [
		{county: "Atlantic", code: "1"},
		{county: "Bergen", code: "3"},
		{county: "Burlington", code: "5"},
		{county: "Camden", code: "7"},
		{county: "Cape May", code: "9"},
		{county: "Cumberland", code: "11"},
		{county: "Essex", code: "13"},
		{county: "Gloucester", code: "15"},
		{county: "Hudson", code: "17"},
		{county: "Hunterdon", code: "19"},
		{county: "Mercer", code: "21"},
		{county: "Middlesex", code: "23"},
		{county: "Monmouth", code: "25"},
		{county: "Morris", code: "27"},
		{county: "Ocean", code: "29"},
		{county: "Passaic", code: "31"},
		{county: "Salem", code: "33"},
		{county: "Somerset", code: "35"},
		{county: "Sussex", code: "37"},
		{county: "Union", code: "39"},
		{county: "Warren", code: "41"}
	];
	const select = document.getElementById("selectCounty");

	for (let i = 0; i < counties.length; i++) {
		let option = document.createElement("option");

		if (counties[i].code === '23') { // Middlesex County
			option.selected = true;
		}

		option.textContent = counties[i].county;
		option.value = counties[i].code;
		select.appendChild(option);
	}
}

function filterByCounty() {
	makeGraph();
}

window.filterByCounty = filterByCounty;

makeSelect();


function lazyLoad() {
    if ("IntersectionObserver" in window) {
        let options = {
            rootMargin: '5px',
            threshold: 0
        };
        let myD3 = document.getElementById('myD3');
        let observer = new IntersectionObserver(function (entries, self) {
            let isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0;
            if (isIntersecting) {
				makeGraph();

				self.unobserve(myD3);
            }
        }, options);
        observer.observe(myD3);
    } else {
		makeGraph();
    }
}


if (sessionStorage.getItem("njData2017_2022") === null) {
	csv("/Scripts/NJ-Tax-Rates-History-2015-2022.csv")
		.then(function (data) {

		    data = data.filter(function (row) {
                return row['Year'] > 2016;
            });

			sessionStorage.setItem('njData2017_2022', JSON.stringify(data));
			lazyLoad();
		});
} else {
	lazyLoad();
}


let myTooltips = [];

// tooltips
// this takes the most time, according to DevTools Performance
function setTooltips() {
	myTooltips.forEach(function (t) {t.destroy();});
	// select the data points
	let myDataPoints = select("#myD3").selectAll('.rect');

	// set tooltip content
	myDataPoints.attr('data-tippy-content', function (d) {
		return `<b>${d.Town}, NJ</b><br>Tax Rate: ${d.General}<br>Year: ${d.Year}`;
	});
	// call tippy on the data points
	myTooltips = tippy(myDataPoints.nodes(), {
		delay: [400, 100],
		//duration: [500, 200],
		allowHTML: true,
		placement: 'top',
		arrow: roundArrow,
		theme: 'light'
	});
}


function makeGraph() {
	let data = JSON.parse(sessionStorage.getItem("njData2017_2022"));
	const selectCounty = document.getElementById("selectCounty");
	let selectedCounty = selectCounty.value;

	// filter data based on selected county
	if (selectedCounty !== '-1') {
		data = data.filter(function (row) {
			return row['CountyCode'] === selectedCounty;
		});
	}

	// set dimensions and margins of graph
	const margin = {top: 40, right: 100, bottom: 200, left: 130};
	const width = 600 - margin.left - margin.right;
	//let height = 800 - margin.top - margin.bottom;
	const height = (data.length / 6) * (15 + 4);
	const responsiveDivHeight = (data.length / 6) * (15 + 4) + margin.top + 50;

	select("#legend").selectAll("*").remove();
	select("#myD3").selectAll("*").remove();

	const svg = select("#myD3")
		.append("svg")
		.attr('height', '100%')
		.attr('width', '100%')
		.attr('viewBox', '0 0 500 ' + responsiveDivHeight + '')
		.attr('preserveAspectRatio', 'xMinYMin')
		.append("g")
		.attr("transform", `translate(${margin.left}, ${margin.top})`); // shift to show top x-axis and y-axis

	svg.append('text')
		.attr('class', 'legendText bold')
		.text('Tap or hover any rectangle below for more information')
		.attr("transform", "translate(30, -26)");


	// arrays for row and column labels
	const myYears = Array.from(new Set(data.map(d => d.Year)));
	const myTowns = Array.from(new Set(data.map(d => d.Town)));

	// build X scales and axis
	const x = scaleBand()
		.range([0, width])
		.domain(myYears)
		.padding(0.05);
	// top x-axis
	svg.append("g")
		.style("font-size", 12)
		.attr("transform", "translate(-15, -5)")
		.call(axisTop(x).tickSize(0))
		.select(".domain").remove();
	// bottom x-axis
	svg.append("g")
		.style("font-size", 12)
		.attr("transform", `translate(-15, ${height})`)
		.call(axisBottom(x).tickSize(0))
		.select(".domain").remove();

	// build Y scales and axis
	const y = scaleBand()
		.range([0, height])
		.domain(myTowns)
		.padding(0.05);
	// y-axis
	svg.append("g")
		.style("font-size", 12)
		.call(axisLeft(y).tickSize(0))
		.select(".domain").remove();

	// set color based on tax rate
	const myColor = function (r) {
		let c = "red";
		return r < lowRate ? c = "green" : r >= lowRate && r < highRate && (c = "yellow"), c;
	};

	// add datapoints
	svg.selectAll()
		.data(data, function (d) {
			// return d.Year;
		})
		.join("rect")
		.attr("x", function (d) {
			return x(d.Year);
		})
		.attr("y", function (d) {
			return y(d.Town);
		})
		.attr("rx", 4)
		.attr("ry", 4)
		.attr('width', '30')
		.attr('height', '15')
		.attr("class", "rect")
		.style("fill", function (d) {
			return myColor(d.General);
		})
		.style("stroke-width", 1)
		.style("stroke", "gray");

	const legend = select("#legend")
		.append("svg")
		.attr('height', '100%')
		.attr('width', '100%')
		.attr('viewBox', '0 0 500 30') // min-x, min-y, width, height
		.attr('preserveAspectRatio', 'xMinYMin')
		.append("g")
		.attr("transform", `translate(${margin.left + 30}, 0)`);

	const rectWidth = 30;
	const rectHeight = 15;

	legend.append("rect")
		.attr("x", 10).attr("y", 10)
		.attr("rx", 4).attr("ry", 4)
		.attr('width', rectWidth).attr('height', rectHeight)
		.style("fill", 'green')
		.style("stroke-width", 1)
		.style("stroke", "gray")
		.append('title').text('Tax Rate Less Than ' + lowRate);

	legend.append('text')
		.attr('x', rectWidth + 14).attr('y', 22)
		.attr('class', 'legendText')
		.text('Low');

	legend.append("rect")
		.attr("x", rectWidth + 80).attr("y", 10)
		.attr("rx", 4).attr("ry", 4)
		.attr('width', rectWidth).attr('height', rectHeight)
		.style("fill", 'yellow')
		.style("stroke-width", 1)
		.style("stroke", "gray")
		.append('title').text('Tax Rate Between ' + lowRate + ' and ' + highRate);

	legend.append('text')
		.attr('x', rectWidth + 80 + 34).attr('y', 22)
		.attr('class', 'legendText')
		.text('Medium');

	legend.append("rect")
		.attr("x", rectWidth + 200).attr("y", 10)
		.attr("rx", 4).attr("ry", 4)
		.attr('width', rectWidth).attr('height', rectHeight)
		.style("fill", 'red')
		.style("stroke-width", 1)
		.style("stroke", "gray")
		.append('title').text('Tax Rate More Than ' + highRate);

	legend.append('text')
		.attr('x', rectWidth + 236).attr('y', 22)
		.attr('class', 'legendText')
		.text('High');

		setTooltips();
}
